<template>
  <div>
    <page-title
      heading="Manajemen Komisi"
      :breadcrumb="[
        {
          label: 'Manajamen Komisi',
          link: '/komisi',
        },
        {
          label: 'Tambah',
          active: true,
        },
      ]"
    />
    <div class="container-fluid">
      <div class="card card-box mb-3 ninja-shadow">
        <div class="card-body">
          <div class="row mb-4 lb-header">
            <div class="col-md-4">Nama Layanan/Obat/BHP</div>
            <div class="col-md-2">Jenis User</div>
            <div class="col-md-2">Tipe Komisi</div>
            <div class="col-md-2">Nilai Komisi</div>
            <div class="col-md-2"></div>
          </div>
          <div
            class="row mb-3"
            v-for="(item, index) in comitionCollection"
            :key="index"
          >
            <!-- <div class="col">
              <vue-select
                style="font-size: 13px; height: auto"
                :options="serviceTypeOpt"
				:reduce="item => item.item.value"
                v-model="comitionCollection[index].layanan_id"
                v-show="index == 0"
                placeholder="Pilih Layanan"
              />
            </div> -->
			<div class="col serviceAddSchema">
				<multiselect
				v-model="comitionCollection[index].layanan" 
				:options="serviceTypeOpt" 
				group-values="libs" 
				group-label="layanan" 
				:group-select="true" 
				placeholder="Type to search" 
				v-show="index == 0"
				@input="changeServiceType($event)"
				:show-labels="false"
				:disabled="isEdit ? true : false"
				:class="{'is-invalid' : comitionCollection[index].errorLayanan}"
				track-by="name" label="name"><span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
				<template slot="option" slot-scope="props">
					<span style="padding-left: 20px;" v-if="props.option.$isLabel">{{ props.option.$groupLabel }}</span>
					<span style="padding-left: 40px;" v-else>{{ props.option.name }}</span>
				</template>
				</multiselect>
				<div class="text-danger" v-show="index == 0" :class="{'d-none' : !comitionCollection[index].errorLayanan}">
			  		{{comitionCollection[index].errorLayananMsg}}
			  	</div>
            </div>
			<div class="col-md-2 serviceAddSchema">
			  <multiselect 
			  	v-model="comitionCollection[index].role" 
			  	:options="userTypeOpt" 
				placeholder="Jenis User" 
				label="name" 
				track-by="name"
				@input="changeUserType($event, index)"
				:show-labels="false"
				:disabled="isEdit ? true : false"
				:class="{'is-invalid' : comitionCollection[index].errorUserType}">
			  </multiselect>
              <div class="text-danger" :class="{'d-none' : !comitionCollection[index].errorUserType}">
			  	{{comitionCollection[index].errorUserTypeMsg}}
			  </div>
            </div>
            <div class="col-md-2 serviceAddSchema">
			  <multiselect 
			  	v-model="comitionCollection[index].type" 
			  	:options="comitionTypeOpt" 
				placeholder="Tipe Komisi" 
				label="name" 
				:show-labels="false"
				@input="changeComitionType($event, index)"
				:class="{'is-invalid' : comitionCollection[index].errorComitionType}"
				track-by="name">
			  </multiselect>
			  <div class="text-danger" :class="{'d-none' : !comitionCollection[index].errorComitionType}">
			  	{{comitionCollection[index].errorComitionTypeMsg}}
			  </div>
            </div>
            <div class="col-md-2">
              <b-form-input
                v-model="comitionCollection[index].amount"
                :type="'number'"
				:class="{'is-invalid' : comitionCollection[index].errorAmount}"
                @keyup="isValidComition($event.target.value, index)"
				@click="isValidComition($event.target.value, index)"
              ></b-form-input>
			  <div class="text-danger" :class="{'d-none' : !comitionCollection[index].errorAmount}">
			  	{{comitionCollection[index].errorAmountMsg}}
			  </div>
            </div>
            <div class="col-md-2">
              <b-button
                variant="danger"
                style="
                  padding: 0.5rem 0.8rem;
                  border-radius: 100%;
                  margin-right: 15px;
                "
                v-show="comitionCollection.length > 1"
                @click="removeComition(index)"
              >
                <font-awesome-icon icon="minus" />
              </b-button>
              <b-button
                variant="first"
                class="mr-3"
                style="padding: 0.5rem 0.8rem; border-radius: 100%"
				v-show="index == (comitionCollection.length - 1) && !isEdit"
                @click="addComition(comitionCollection[index], index)"
              >
                <font-awesome-icon icon="plus" />
              </b-button>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-md-12 text-right">
              <b-button class="text-capitalize mr-2" variant="danger" @click="removeComitionScheme()"
                >Batal</b-button
              >
              <b-button class="text-capitalize" type="submit" variant="primary" :disabled="errorValidation" @click="saveComitionScheme()"
                >Simpan</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import startCase from "lodash/startCase";
import Multiselect from 'vue-multiselect'
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPlus,
  faMinus,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
library.add(faPlus, faMinus, faInfoCircle);

import axios from "axios";
export default {
  components: {
	Multiselect,
    // "vue-select": () => import("@/components/VueSelect.vue")
  },
  data() {
    return {
	  isEdit: this.$route.params.idComition,
      userTypeOpt: [],
	  serviceTypeOpt: [],
      comitionTypeOpt: [
        {
          name: "%",
          value: "persen",
        },
        {
          name: "Rp",
          value: "rupiah",
        },
      ],
      comitionCollection: [
        this.getInitialComition()
      ],
	  errorValidation: true
    };
  },
  computed: {
	...mapGetters(["getKlinikId"]),
  },
  created() {
    this.getServiceList();
    this.getUserType();
	if(this.isEdit) this.getComitionSchemeDetail()
	
  },
  methods: {
	getDummy() {
		return new Promise((resolve, reject) => {
			setTimeout(function() {
				resolve([
					{	
						layanan: {id: 4061, name: "Regsitrasi - A001"},
						role: {name: "Dokter", value: 3},
						type: {name: "%", value: 'persen'},
						amount: 10000,
					},
					{	
						layanan: {id: 4061, name: "Regsitrasi - A001"},
						role: {label: "Perawat", value: 4},
						type: {label: "Rp", value: 'rupiah'},
						amount: 10000,
					},
				])	
			}, 300)
		})

	},
	async getComitionSchemeDetail() {
		const response = await axios.get(`${this.url_api}/klinik/komisi/${this.isEdit}`);
		let {status, data} = response.data;

		
		if(!Array.isArray(data)) {
			data.amount = parseFloat(data.amount)
			data.price = parseFloat(data.layanan.amount),
			data.amount = parseFloat(data.amount),
			data.amountTemp = parseFloat(data.amount),
			data.amountRole = parseFloat(data.amountRole),
			data.amountFirst = parseFloat(data.amount),
			data = [data];
		}

		for(let dm of data) {
			dm.role.name = dm.role.label
			delete dm.role.label
			dm.type.name = dm.type.label
			delete dm.type.label
		}
		
		this.comitionCollection = data;
	},
    async getUserType() {
      const response = await axios.get(`${this.url_api}/klinik/list-role`);
      this.userTypeOpt = response.data.data.map((item) => ({
        name: item.display_name,
        value: item.id,
      }));
    },
    async getServiceList() {
      const response = await axios.get(
        `${this.url_api}/klinik/list-layanan?klinik_id=${this.getKlinikId}`
      );
      let serviceList = response.data.data;

	  for(let key in serviceList) {
		this.serviceTypeOpt.push({
			layanan: key,
			libs: serviceList[key].map(item => ({name: item.text, id: item.id, amount: item.price || 1000000000}))
		})
	  }
    },
	getInitialComition() {
		return {
			layanan: "",
			role: "",
			type: {
				name: "%",
				value: "persen"
			},
			amount: 0,
			errorComitionType: false,
			errorComitionTypeMsg: '',
			errorLayanan: false,
			errorlayananMsg: '',
			errorUserType: false,
			errorUserTypeMsg: '',
			errorAmount: false,
			errorAmountMsg: ''
		}
	},
	async changeServiceType(e) {
		let initOpt = this.getInitialComition();
		this.comitionCollection = [initOpt]
		
		if(e) {
			let id = e.id;
			const response = await axios.get(`${this.url_api}/klinik/check-layanan?layanan_id=${id}&klinik_id=${this.getKlinikId}`);
			const {status, data} = response.data;

			// const response = await this.getDummy();
			initOpt.layanan = e
			if(data.length > 0) {
				this.comitionCollection = data.map(item => {
					return {
						...item,
						amount: parseFloat(item.amount),
						amountTemp: parseFloat(item.amount),
						layanan: e
					}
				})
				this.errorValidation = false;
			} else {
				this.comitionCollection =this.comitionCollection.map(item => {
					return {
						...item,
						price: parseFloat(e.amount),
						amount: 0,
						amountTemp: parseFloat(e.amount),
						layanan: e
					}
				})
				this.errorValidation = true;
			}
		}

	},
	isEmpty(e, field, index) {
		let msg = `${field} harus diisi`;

		if(field == 'Role') {
			field = 'UserType';
			msg = "Jenis user harus diisi";
		} else if(field == 'Type') {
			field = 'ComitionType';
			msg = "Tipe komisi harus diisi";
		} else if(field == 'Amount') {
			e = String(e);
		}

		if(!e && (e != '0')) { 	
			this.setErrorValidation(true, index, `error${field}`, msg) ;
			return true;
		} else {
			this.setErrorValidation(false, index, `error${field}`, '');
			return false;
		}
	},
	isDuplicateUserType(e, index) {
		for(let [i, comition] of this.comitionCollection.entries()) {	
			if(i == index) continue;
			if(e.value == comition.role.value) return true;
		}
	},
	isComitionGtPrice(index, value) {
		this.comitionCollection[index].amountTemp = value;
		let totalComition = 0;
		if(!this.isEdit) {
			totalComition = this.comitionCollection.reduce((temp, val) => {
				return temp += val.amountTemp
			}, 0);
		} else {
			totalComition = value + parseFloat(this.comitionCollection[0].amountRole) - this.comitionCollection[0].amountFirst
		}
		
		return totalComition > this.comitionCollection[0].price ? true : false;
	},
	isValidComition(e, index) {
		let value = parseFloat(e)
		this.setErrorValidation(false, index, 'errorAmount', '')
		if(this.comitionCollection[index].type) {
			if(this.comitionCollection[index].type.value == 'persen') {
				let nominal = (e / 100) * this.comitionCollection[0].price;
					nominal = Math.round(nominal * 100) / 100

				let isGtprice = this.isComitionGtPrice(index, nominal);
				if(isGtprice) {
					this.setErrorValidation(true, index, 'errorAmount', 'Nilai Komisi harus lebih kecil dari harga layanan/obat/BHP');
					return false;
				}
				if(value <= 0) {
					this.setErrorValidation(true, index, 'errorAmount', 'Nilai komisi tidak valid');
					return false;
				} else if (value > 100) {
					this.setErrorValidation(true, index, 'errorAmount', 'Nilai Komisi harus lebih kecil dari harga layanan/obat/BHP');
					return false;
				}
			}else {
				let isGtprice = this.isComitionGtPrice(index, value);
				if(isGtprice) {
					this.setErrorValidation(true, index, 'errorAmount', 'Nilai Komisi harus lebih kecil dari harga layanan/obat/BHP');
					return false;
				}
				if(value <= 0) {
					this.setErrorValidation(true, index, 'errorAmount', 'Nilai Komisi tidak valid');
					return false;
				} else if(value > this.comitionCollection[index].layanan.amount) {
					this.setErrorValidation(true, index, 'errorAmount', 'Nilai Komisi harus lebih kecil dari harga layanan/obat/BHP');
					return false;
				}
			}
		}

		return true;
	},
	changeUserType(e, index) {
		this.setErrorValidation(false, index, 'errorUserType', '')
		if(this.isDuplicateUserType(e, index)) {
			this.setErrorValidation(true, index, 'errorUserType', 'Duplikat data jenis user');
		}
	},
	changeComitionType(e, index) {
		this.isEmpty(e, 'Type', index)
		this.isValidComition(this.comitionCollection[index].amount, index)
	},
	setErrorValidation(status, index, attr, msg) {
		this.comitionCollection[index][attr] = status;
		this.comitionCollection[index][`${attr}Msg`] = status ? msg : '';
		this.errorRow = status;
		this.errorValidation = status;
	},
    addComition(data, index) {
	
		let isValidData = true;
		let requiredField = ['layanan', 'role', 'type', 'amount']
		
		// if(!data.layanan || !data.role || !data.type || data.amount == 0) {
		// 	this.$swal({
		// 		type: "warning",
		// 		title: 'Perhatian',
		// 		text: 'Pastikan semua data terisi',
		// 	});
		// 	return;
		// }

		for(let field of requiredField) {
			if(this.isEmpty(data[field], startCase(field), index)) {
				isValidData = false;
			}
		}

		if(this.isDuplicateUserType(data.role, index)) {
			this.setErrorValidation(true, index, 'errorUserType', 'Duplikat data jenis user');
			isValidData = false;
		}


		if(!this.isValidComition(data.amount, index))  {
			isValidData = false;
		}
		
		if(!isValidData) return
		
		this.comitionCollection.push(this.getInitialComition());
		this.comitionCollection[index + 1].layanan = this.comitionCollection[0].layanan;
    },
    removeComition(index) {
      this.comitionCollection.splice(index, 1);
    },
	removeComitionScheme() {
		this.$swal({
			html: `Apakah Anda yakin untuk membatalkan skema komisi ? <br/> Data yang telah ditulis tidak akan tersimpan.`,
			type: "warning",
			showCancelButton: true,
			cancelButtonText: "Tidak",
			confirmButtonText: "Ya",
			width: "550px"
		}).then(async (res) => {
			if (res.value) {
				this.$router.push({name: 'klinik-komisi-list'}) 
			}
		});
		// this.comitionCollection = [this.getInitialComition()];
	},
	async saveComitionScheme() {
		let countRow = this.comitionCollection.length,
			lastData = this.comitionCollection[countRow - 1];
			lastData.layanan = this.comitionCollection[0].layanan;


		let attr = ['layanan', 'role', 'type', 'amount']
		for(let x of attr) {
			if(!lastData[x]) {
				this.$swal({
					type: "warning",
					title: 'Perhatian',
					text: 'Pastikan semua data terisi',
				});
				return;
			}
		}

		let roles = [],
			formatComition = [],
			isDuplicate = false;

		for(let item of this.comitionCollection) {
			if(roles.includes(item.role.value)) {
				isDuplicate = true
				break;
			} else {
				roles.push(item.role.value)
				formatComition.push({
					role_id: item.role.value,
					type: item.type.value,
					amount: item.amount,
				})
			}

		}

		if(isDuplicate) {
			this.$swal({
				type: "warning",
				title: 'Perhatian',
				text: 'Terdapat duplikat data',
			});
			return;
		}
		// let formatComition = [...this.comitionCollection].map((item) => {
		// 	return {
		// 		role_id: item.role.value,
        // 		type: item.type.value,
        // 		amount: item.amount,
		// 	}
		// })
		

		let dataBody = {
			klinik_id: this.getKlinikId,
			layanan_id: this.comitionCollection[0].layanan.id,
			komisi: formatComition
		}

		let response = {}
		if(this.isEdit) {
			dataBody.id = this.isEdit;
			response = await axios.put(
				`${this.url_api}/klinik/komisi`,
				dataBody
			);
		}else
			response = await axios.post(
				`${this.url_api}/klinik/komisi`,
				dataBody
			);

		const {status, message, data} = response.data

		if(status) {
			this.$swal({
				type: "success",
				title: 'Success',
				text: `Skema komisi berhasil ${this.isEdit ? 'diupdate' : 'ditambahkan!'}`,
			});

			this.$router.push({name: 'klinik-komisi-list'});
		}
	}
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="css">
.serviceAddSchema .multiselect {
	z-index: 99 !important;
}

.serviceAddSchema .multiselect .multiselect__input, 
.serviceAddSchema .multiselect .multiselect__single {
    /* line-height: 13px; */
    font-size: 14px;
}
.lb-header {
  color: #217fc3;
  font-weight: 600;
}

.is-invalid {
	border: 1px solid red;
	border-radius: 0.29rem;
}

.text-danger {
	font-size: 7.4pt;
}
</style>
